<template>
    <vue-autocomplete
    class="w-100"
    :data="items"
    placeholder="Procurar Pessoa Jurídica"
    v-model="query"
    :serializer="item => item.pessoa"
    @hit="selecionarPessoa($event)"
    @input="buscarPessoasJuridicas"
    showOnFocus
    :disabled="disabled"
    :maxMatches=parseInt(5)
    >
  <template slot="suggestion" slot-scope="{ htmlText }">
    <div class="d-flex">
        <b-spinner v-show="carregando" variant="primary" class="mx-auto"></b-spinner>
        <span class="ml-4" v-html="htmlText" v-show="!carregando"></span>
    </div>
  </template>
</vue-autocomplete>
</template>
<script>
import PessoaService from "../../service/PessoaService.js";

export default {
	props: [ "disabled" ],
	data() {
		return {
			query: "",
			items: [],
			carregando: false,
		};
	},
	methods: {
		buscarPessoasJuridicas(query) {
			this.carregando = true;
			let termoDePesquisa = query;
			if (this.ehCnpj(termoDePesquisa)) {
				termoDePesquisa = this.$options.filters.removeMascara(query);
			}
			PessoaService.filtrarPessoasJuridicas(termoDePesquisa)
				.then((res) => {
					const arr = [];
					res.data.forEach((p) => {
						const pessoa = {
							pessoa: p[0],
							cnpj: p[1],
						};
						arr.push(pessoa);
					});
					this.items = arr;
				}).finally(() => {
					this.carregando = false;
				});
		},
		selecionarPessoa(item) {
			this.$emit("pessoaSelecionada", item.cnpj);
		},
		ehCnpj(str) {
			const cnpj = /^[0-9.]+$/;
			if (cnpj.test(str)) {
				return true;
			} else {
				return false;
			}
		},
		limpar() {
			this.query = "";
			this.items = [];
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/pessoa/AutoCompletePessoaJuridica.vue